import { RedoOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import PieChart from './PieChart';
import { CirclePie, StatusPie } from './CirclePie';
import card1 from './icons/card1.svg';
import card2 from './icons/card2.svg';
import card3 from './icons/card3.svg';
import useDashboard from './hook/useDashboard';

export default function DashboardDataBreach() {
    const { t } = useTranslation();

    const { summary, getSummaryDetail } = useDashboard();
    const [refresh, setRefresh] = useState(true);
    const [dateNow, setDateNow] = useState(new Date());

    useEffect(() => {
        if (refresh) {
            getSummaryDetail();
            setRefresh(false);
            setDateNow(new Date());
        }
    }, [getSummaryDetail, refresh]);

    const items = useMemo(
        () => [
            {
                key: '1',
                title: t('Total incidents recorded'),
                value: 0,
                color: '#F65464',
                icon: card1,
            },
            {
                key: '2',
                title: t('Not resolved'),
                value: 0,
                color: '#FCA652',
                icon: card2,
            },
            {
                key: '3',
                title: t('Mean Time to Resolve'),
                value: 0,
                color: '#1890FF',
                icon: card3,
            },
        ],
        [t]
    );

    useEffect(() => {
        if (summary) {
            items[0].value = summary.totalIncident;
            items[1].value = summary.inProgressIncident;
            items[2].value = summary.meanTime;
        }
    }, [items, summary]);

    return (
        <div>
            <div className="title ">{t('common.Dashboard')}</div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {' '}
                    {t('Data Breach')} /{' '}
                </span>
                <span> {t('Dashboard')}</span>
            </div>
            <div className="space-y-6 mt-6">
                <div className="py-4 px-6 bg-white rounded-md flex justify-between items-center">
                    <span className="text-xl text-purple">
                        {t('Overview of incidents')}
                    </span>
                    <div className="text-right flex items-center space-x-2 justify-end">
                        <div className="text-sm text-[#65707A]">
                            {t('LastUpdate')} :{' '}
                            {moment(dateNow).format('DD/MM/YYYY HH:mm')}
                        </div>
                        <Button
                            onClick={() => setRefresh(true)}
                            icon={<RedoOutlined />}
                            type="primary"
                            size="large"
                            className="bg-[#65707A] text-base border-none"
                        >
                            {t('Refresh')}
                        </Button>
                    </div>
                </div>
                <div className="grid grid-cols-4 gap-4">
                    {items.map((item) => (
                        <div
                            key={item.key}
                            className="col-span-1 bg-white shadow-md rounded-lg p-6 h-48 relative"
                            style={{
                                borderTop: `10px solid ${item.color}`,
                                background: `url(${item.icon}) bottom right no-repeat`,
                            }}
                        >
                            <div className="text-lg font-medium">
                                {item.title}
                            </div>
                            <div className="text-[55px]">{item.value}</div>
                            {/* <div className="absolute -bottom-1.5 right-0 rounded-br-lg">
                                {item.icon}
                            </div> */}
                        </div>
                    ))}
                    <div className="col-span-1 bg-white shadow-md rounded-lg p-6 h-48 relative">
                        <div className="text-lg font-medium mb-4">
                            {t('Reporting Channel')}
                        </div>
                        <div>
                            <CirclePie summary={summary} />
                        </div>
                    </div>
                    <div className="col-span-3 bg-white shadow-md rounded-lg p-6 w-full">
                        <PieChart setRefresh={setRefresh} refresh={refresh} />
                    </div>
                    <div className="col-span-1 bg-white shadow-md rounded-lg p-6">
                        <div className="text-lg font-semibold">
                            {t('Incidents divided by status')}
                        </div>
                        <div>
                            <StatusPie summary={summary} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
